import createReducer from 'utils/createReducer';
import {
  SET_DISCOUNT_RULES_LOADING,
  SHOW_CREATE_DISCOUNT_RULE_MODAL,
  SHOW_DELETE_CONFIRMATION_MODAL,
  SHOW_EDIT_DISCOUNT_RULE_MODAL,
  SHOW_EDITOR_MODAL_LOADING,
  SET_EDITOR_ERROR_MESSAGE,
  UPDATE_DISCOUNT_RULES,
  DISCOUNT_RULE_LOG_SET_SHOWN,
  DISCOUNT_RULE_LOG_SET_DATA,
  DISCOUNT_RULE_LOG_SET_IS_LOADING,
  DISCOUNT_RULE_LOG_SET_ERRORS,
} from './actionTypes';

const initialState = {
  discountRules: [],
  isLoading: false,
  editor: {
    isOpen: false,
    isEditMode: false,
    editingRule: null,
    isLoading: false,
    errorMessage: null,
  },
  deleteConfirmation: {
    isOpen: false,
    isLoading: false,
    deleteingRule: null,
  },
  log: {
    shown: false,
    isLoading: false,
    data: [],
    paging: {
      page: 1,
      size: 20,
      total: 0,
    },
    errors: [],
  },
};

const updateDiscountRules = (state, action) => ({
  ...state,
  discountRules: action.payload,
});

const setDiscountRulesLoading = (state, action) => ({
  ...state,
  isLoading: action.payload,
});

const showCreateDiscountRuleModal = (state, action) => ({
  ...state,
  editor: {
    ...state.editor,
    isOpen: action.payload,
    isEditMode: false,
    editingRule: null,
    errorMessage: null,
  },
});

const showEditDiscountRuleModal = (state, action) => ({
  ...state,
  editor: {
    ...state.editor,
    isOpen: action.payload.shown,
    isEditMode: true,
    editingRule: action.payload.discountRule,
    errorMessage: null,
  },
});

const showEditorModalLoading = (state, action) => ({
  ...state,
  editor: {
    ...state.editor,
    isLoading: action.payload,
  },
});

const showDeleteConfirmationModal = (state, action) => ({
  ...state,
  deleteConfirmation: {
    ...state.deleteConfirmation,
    isOpen: action.payload.shown,
    deleteingRule: action.payload.discountRule,
  },
});

const setEditorErrorMessage = (state, action) => ({
  ...state,
  editor: {
    ...state.editor,
    errorMessage: action.payload,
  },
});

export default createReducer(initialState, {
  [UPDATE_DISCOUNT_RULES]: updateDiscountRules,
  [SET_DISCOUNT_RULES_LOADING]: setDiscountRulesLoading,
  [SHOW_CREATE_DISCOUNT_RULE_MODAL]: showCreateDiscountRuleModal,
  [SHOW_EDIT_DISCOUNT_RULE_MODAL]: showEditDiscountRuleModal,
  [SHOW_EDITOR_MODAL_LOADING]: showEditorModalLoading,
  [SET_EDITOR_ERROR_MESSAGE]: setEditorErrorMessage,
  [SHOW_DELETE_CONFIRMATION_MODAL]: showDeleteConfirmationModal,
  [DISCOUNT_RULE_LOG_SET_SHOWN]: (draft, { payload }) => {
    draft.log.shown = payload.shown;
  },
  [DISCOUNT_RULE_LOG_SET_DATA]: (draft, { payload }) => {
    draft.log.data = payload.data;
    draft.log.paging = payload.paging;
  },
  [DISCOUNT_RULE_LOG_SET_IS_LOADING]: (draft, { payload }) => {
    draft.log.isLoading = payload.isLoading;
  },
  [DISCOUNT_RULE_LOG_SET_ERRORS]: (draft, { payload }) => {
    draft.log.errors = payload.errors;
  },
});
